import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import UploadFile from "@mui/icons-material/UploadFile";
import FolderOpenTwoTone from "@mui/icons-material/FolderOpenTwoTone";
import { toast } from "react-toastify";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";

toast.configure();

const Transit = () => {
  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) return <Redirect exact to="/sparepartsLogin" />;
  };

  // JWT timeout (your original)
  setTimeout(() => {
    window.location.reload(false);
  }, 1800000);

  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [busy, setBusy] = useState(false);
  const [missingTransitData, setMissingTransitData] = useState([]);
  const [existinginvoices, setExistingInvoices] = useState([]);

  const handleUploadImport = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Select a .xlsx file first");

    if (!file.name.toLowerCase().endsWith(".xlsx")) {
      return toast.error("Only .xlsx supported");
    }

    try {
      setBusy(true);
      setExistingInvoices([]);

      // 1) Validate
      const fd1 = new FormData();
      fd1.append("file", file);

      const vRes = await fetch("/upload/transit?dryrun=1", {
        method: "POST",
        headers: { sptoken: userToken },
        body: fd1,
      });

      const vData = await vRes.json();

      if (!vRes.ok) {
        toast.error(vData.message || "Validation failed");
        setBusy(false);
        return;
      }

      if (vData.type === "missing") {
        toast.error(vData.message || "Missing required headers");
        console.log("Missing headers:", vData.data);
        setMissingTransitData(vData.data);
        setBusy(false);
        return;
      }

      // 2) Decide import URL
      let importUrl = "/upload/transit";

      if (vData.type === "overwrite") {
        setExistingInvoices(vData.data || []);
        const ok = window.confirm(
          vData.message || "Invoices exist. Overwrite?",
        );
        if (!ok) {
          setBusy(false);
          return;
        }
        importUrl = "/upload/transit?overwrite=1";
      } else if (vData.existing_invoices) {
        setExistingInvoices(vData.existing_invoices);
      }

      // 3) Import
      const fd2 = new FormData();
      fd2.append("file", file);

      const iRes = await fetch(importUrl, {
        method: "POST",
        headers: { sptoken: userToken },
        body: fd2,
      });

      const iData = await iRes.json();

      if (!iRes.ok) {
        toast.error(iData.message || "Import failed");
        setBusy(false);
        return;
      }

      toast.success(iData.message || "Imported successfully", {
        autoClose: false,
        onClose: () => window.location.reload(false),
      });
    } catch (err) {
      console.log(err.message);
      toast.error(err.message);
      setBusy(false);
    }
  };

  return (
    <div>
      <Sidebar
        Title={"TRANSIT UPLOAD NEW"}
        expandedPanel={"panel4"}
        children={
          <Box component="form" sx={{ width: "100%" }} autoComplete="off">
            <Typography variant="h5" align="center" mt={"24px"} mb={4}>
              SELECT THE .XLSX FILE TO IMPORT
            </Typography>
            <hr />

            <Stack
              spacing={2}
              ml={"34%"}
              mt={"100px"}
              direction="row"
              alignItems="center"
            >
              <IconButton
                aria-label="select file"
                component="label"
                sx={{ color: "#e69b00" }}
              >
                <input
                  type="file"
                  hidden
                  accept=".xlsx"
                  onChange={(e) => {
                    const f = e.target.files?.[0];
                    if (!f) return;
                    setFileName(f.name);
                    setFile(f);
                    setDisabled(false);
                    setExistingInvoices([]);
                  }}
                />
                <FolderOpenTwoTone sx={{ width: "45px", height: "45px" }} />
              </IconButton>

              <TextField
                disabled
                id="filename"
                label="File Name"
                variant="standard"
                value={fileName}
                type="text"
                sx={{ width: "36%" }}
              />
            </Stack>

            {/* ONE BUTTON */}
            <Stack spacing={2} ml={"40%"} mt={"80px"} direction="row">
              <Button
                disabled={disabled || busy}
                type="submit"
                onClick={handleUploadImport}
                variant="contained"
                color="success"
                size="large"
                sx={{ boxShadow: "2px 2px 6px  #404142", px: 5, py: 2 }}
                endIcon={<UploadFile />}
              >
                {busy ? "PROCESSING..." : "UPLOAD & IMPORT"}
              </Button>
            </Stack>
            {/* missing items */}
            {missingTransitData.length > 0 && (
              <Box mt={4}>
                <Typography align="center" variant="h6">
                  Missing Items
                </Typography>
                <Table
                  sx={{
                    maxWidth: 500,
                    margin: "auto",
                    mt: 2,
                    boxShadow: "2px 6px 15px #5a5a5a",
                  }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead
                    sx={{
                      backgroundColor: "#3bb9ff",
                      border: "0.5px solid black",
                    }}
                  >
                    <TableRow>
                      <TableCell
                        sx={{ color: "#000", border: "0.5px solid black" }}
                        align="center"
                      >
                        Srl No.
                      </TableCell>
                      <TableCell
                        sx={{ color: "#000", border: "0.5px solid black" }}
                        align="center"
                      >
                        Part No.
                      </TableCell>
                      <TableCell
                        sx={{ color: "#000", border: "0.5px solid black" }}
                        align="center"
                      >
                        Invoice No.
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {missingTransitData?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell
                          sx={{ color: "#000", border: "0.5px solid black" }}
                          align="center"
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          sx={{ color: "#000", border: "0.5px solid black" }}
                          align="center"
                        >
                          {row.partno}
                        </TableCell>
                        <TableCell
                          sx={{ color: "#000", border: "0.5px solid black" }}
                          align="center"
                        >
                          {row.invno}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
            {/* Existing invoices */}
            {existinginvoices.length > 0 && (
              <Box mt={4}>
                <Typography align="center" variant="h6">
                  Existing Invoices
                </Typography>
                <Table
                  sx={{
                    maxWidth: 500,
                    margin: "auto",
                    mt: 2,
                    boxShadow: "2px 6px 15px #5a5a5a",
                  }}
                  size="small"
                >
                  <TableHead sx={{ backgroundColor: "#3bb9ff" }}>
                    <TableRow>
                      <TableCell sx={{ color: "#000" }} align="center">
                        Srl No.
                      </TableCell>
                      <TableCell sx={{ color: "#000" }} align="center">
                        Invoice No.
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {existinginvoices.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ color: "#000" }} align="center">
                          {index + 1}
                        </TableCell>
                        <TableCell sx={{ color: "#000" }} align="center">
                          {row.invno}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </Box>
        }
      />

      {redirectToLoginPage()}
    </div>
  );
};

export default Transit;
